module.exports = __webpack_public_path__ + "static/media/logo.ba31f0f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 40
// module chunks = 0